import React from "react";

const ServiceItem = (props) => {
  const { icon, title, description } = props.service;
  return (
    <div className="w-full sm:w-1/2 p-2">
      <div className="h-full border border-border rounded p-6 hover:border-cyan transition">
        <div className="w-12 h-12 flex items-center justify-center rounded border border-cyan text-cyan text-xl mb-5">
          {icon}
        </div>
        <h3 className="text-lg font-medium text-text mb-2">{title}</h3>
        <p className="text-prose text-[0.9375rem] leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default ServiceItem;
